<template>
  <div class="Ordesion">
    <div class="Ordesion-background">
      <div class="appHelmetyszf">我的支付<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
      <div class="Ordesion-Payunt">{{orcodity}}</div>
      <div class="Ordesion-Remime">请在30分钟内进行支付</div>
      <div class="Ordesion-mode" v-if="maluerID == '0'">
        <div class="Ordesion-mode-rcptye Ordesion-Lomedicare">
          <div class="Ordesion-mode-choice-left">一卡通余额</div>
          <div class="Ordesion-mode-choice-right"></div>
        </div>
        <div class="Ordesion-mode-retaor Ordesion-Lomedicare">
          <div class="Ordesion-mode-choice-left">一卡通积分</div>
          <div class="Ordesion-mode-choice-right"></div>
        </div>
        <div class="Ordesion-mode-wechat Ordesion-Lomedicare">
          <div class="Ordesion-mode-choice-left">微信</div>
          <div class="Ordesion-mode-choice-right"></div>
        </div>
        <div class="Ordesion-mode-weczfb Ordesion-Lomedicare">
          <div class="Ordesion-mode-choice-left">支付宝</div>
          <div class="Ordesion-mode-choice-right"></div>
        </div>
      </div>
      <div class="Ordesion-mode" v-else-if="maluerID == '1'">
        <div class="Ordesion-mode-retaor">
          <div class="Ordesion-mode-choice-left">积分({{orfaon.lINTEGAR}})</div>
          <div class="Ordesion-mode-choice-right Ordeckyurt"></div>
        </div>
      </div>
      <button class="Ordesion-frame-confirm" @click="ordeImment()">支付</button>
    </div>
    <!-- 微信WeUI样式 -->
    <div id="toast" :style="'display:' + OrdeAppden">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{OrdeConnts}}</p>
      </div>
    </div>
    <div class="js_dialog" id="iosDialog1" :style="'display:' + ordeCasier">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd" style="margin: 0 0 .24rem 0;">确认要离开收银台?</div>
        <div class="weui-dialog__bd">您的订单在30分钟内未支付将被取消,请尽快完成支付</div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_default" @click="ordeConpay()">继续支付</a>
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" style="color: #f84328;" @click="ordeLeaent()">确认离开</a>
        </div>
      </div>
    </div>
    <!-- 微信WeUI样式 -->
    <div class="js_dialog" id="iosDialog2" :style="'display:' + Fisthint">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd">提示</div>
        <div class="weui-dialog__bd">{{Fidasul}}</div>
        <div class="weui-dialog__ft">
          <a role="button" href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" style="color: #FF4D4D;" @click="frclse()">完成</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://pv.sohu.com/cityjson?ie=utf-8"></script>
<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      OrdeAppden: 'none',
      OrdeDicType: '',
      OrdeConnts: '',
      Ordecking: 'none',
      Ordeoinput: '',
      customerID: '',
      ordeesView: '',
      orAderID: '',
      orcodity: '',
      orPrleID: '',
      ordeCarist: false,
      ormaterice: '',
      orntterice: '',
      ordeCasier: 'none',
      ordecip: '',
      ordePaymlink: '',
      ormaue: '',
      ormece: '',
      orinpr: '',
      oroderID: '',
      maluerID: '',
      Fisthint: 'none',
      Fidasul: '',
      orfaon: ''
    }
  },
  created(){
    // 从缓存中获取用户的token
    this.customerID = localStorage.getItem("usertoken");
    // 从缓冲中获取商城的标识
    this.maluerID = localStorage.getItem("usmago");
    // 接收我的订单(Fillrder)传过来的预订单ID和价格
    this.orAderID = this.$route.query.FiAderID;
    this.ormaue = this.$route.query.fimaue;
    this.ormece = this.$route.query.fimece;
    this.orinpr = this.$route.query.fiinpr;
    this.orcodity = this.ormaue;
    // 接收我的订单(Wafopant)传过来的订单ID
    this.oroderID = this.$route.query.waoderID;
    // 获取微信支付需要的cip
    this.ordecip = returnCitySN["cip"];
    // 获取个人信息
    this.$axios.post('wx/findByUserNameAndMessage',this.$qs.stringify({
      ID: this.customerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.orfaon = res.data.userX;
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted(){
    this.Ordesarasota();
  },
  methods:{
    // 判断支付类型
    Ordesarasota(){
      var that = this;
      this.$('.Ordesion-Lomedicare').on('click',function(){
        that.$('.Ordesion-mode-choice-right').removeClass('Ordeckyurt');
        that.$(this).children('.Ordesion-mode-choice-right').addClass('Ordeckyurt');
        that.OrdeDicType = that.$(this).index() - 1;
        if(that.OrdeDicType == '-1'){
          that.orcodity = that.ormece;
        }else if(that.OrdeDicType == '0'){
          that.orcodity = that.orinpr;
        }else{
          that.orcodity = that.ormaue;
        }
      })
    },
    // 点击继续支付触发
    ordeConpay(){
      this.ordeCasier = 'none';
    },
    // 点击确认离开触发
    ordeLeaent(){
      this.$router.push({name: 'Myorder',query: {myTobeid: '1'}});
    },
    // 点击立即支付触发
    ordeImment(){
      if(this.maluerID == '0'){
        if(this.OrdeDicType === ''){
          this.OrdeConnts = '请选择支付方式';
          this.OrdeAppden = 'block';
          let that = this;
          setTimeout(function(){
            that.OrdeAppden = 'none';
          },1400)
        }else{
          if(this.OrdeDicType == '1'){
            if(this.orAderID){
              // 调用微信支付
              this.$axios.post('wx/mallWechantCardPay',this.$qs.stringify({
                ID: this.orAderID,
                cip: this.ordecip,
                MALL_TYPE: this.maluerID
              }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
              .then(res => {
                this.ordePaymlink = res.data.data;
                if(res.data.ret == '0'){
                  window.location.href = this.ordePaymlink + '&redirect_url=https%3A%2F%2Fwd.obraopay.com%2Fobraoios%2Findex.html%23%2FPromarge';
                }else{
                  this.OrdeConnts = res.data.msg;
                  this.OrdeAppden = 'block';
                  let that = this;
                  setTimeout(function(){
                    that.OrdeAppden = 'none';
                  },1400)
                }
              })
              .catch(() => {
                // console.log('未登录获取数据失败');
              });
            }else if(this.oroderID){
              // 调用微信支付
              this.$axios.post('app/mallWechantOrderCardPay',this.$qs.stringify({
                ID: this.oroderID,
                cip: this.ordecip,
                MALL_TYPE: this.maluerID
              }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
              .then(res => {
                this.ordePaymlink = res.data.data;
                if(res.data.ret == '0'){
                  window.location.href = this.ordePaymlink + '&redirect_url=https%3A%2F%2Fwd.obraopay.com%2Fobraoios%2Findex.html%23%2FPromarge';
                }else{
                  this.OrdeConnts = res.data.msg;
                  this.OrdeAppden = 'block';
                  let that = this;
                  setTimeout(function(){
                    that.OrdeAppden = 'none';
                  },1400)
                }
              })
              .catch(() => {
                // console.log('未登录获取数据失败');
              });
            }
          }else if(this.OrdeDicType == '2'){
            if(this.orAderID){
              // 调用支付宝支付
              this.$axios.post('wx/mallPayAlibabaCard',this.$qs.stringify({
                ID: this.orAderID,
                MALL_TYPE: this.maluerID
              }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
              .then(res => {
                if(res.status == '200'){
                  let divForm = document.getElementsByTagName('divform');
                  if(divForm.length){
                    document.body.removeChild(divForm[0]);
                  }
                  const div = document.createElement('divform');
                  div.innerHTML = res.data; // data就是接口返回的form 表单字符串
                  document.body.appendChild(div);
                  document.forms[0].submit();
                }
              })
              .catch(() => {
                // console.log('未登录获取数据失败');
              });
            }else if(this.oroderID){
              // 调用支付宝支付
              this.$axios.post('app/mallPayAlibabaOrderPay',this.$qs.stringify({
                ID: this.oroderID,
                MALL_TYPE: this.maluerID
              }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
              .then(res => {
                if(res.status == '200'){
                  let divForm = document.getElementsByTagName('divform');
                  if(divForm.length){
                    document.body.removeChild(divForm[0]);
                  }
                  const div = document.createElement('divform');
                  div.innerHTML = res.data; // data就是接口返回的form 表单字符串
                  document.body.appendChild(div);
                  document.forms[0].submit();
                }
              })
              .catch(() => {
                // console.log('未登录获取数据失败');
              });
            }
          }else{
            this.$router.push({name: 'resevabr',query:{orAdvanc: this.orAderID,orodmyer: this.oroderID,oraymeod: this.OrdeDicType,ortodyce: this.orcodity}});
          }
        }
      }else if(this.maluerID == '1'){
        if(this.orAderID){
          // 发送给后台相关信息进行积分商品扣款
          this.$axios.post('wx/andoroidmallpay',this.$qs.stringify({
            ID: this.orAderID,
            payState: '4',
            MEMBER_ID: this.customerID,
            AMOUNT: this.orcodity,
            MALL_TYPE: this.maluerID
          }),{headers:{'token': this.customerID}})
          .then(res => {
            if(res.data.flag == '0'){
              this.Fidasul = '礼品兑换成功';
              this.Fisthint = 'block';
            }else{
              this.OrdeConnts = res.data.msg;
              this.OrdeAppden = 'block'
              let that = this
              setTimeout(function(){
                that.OrdeAppden = 'none';
              },1400)
            }
          })
          .catch(() => {
            console.log('获取数据失败');
          });
        }else if(this.oroderID){
          // 发送给后台相关信息进行积分商品扣款
          this.$axios.post('app/andoroidOrderpay',this.$qs.stringify({
            ID: this.oroderID,
            payState: '4',
            MEMBER_ID: this.customerID,
            AMOUNT: this.orcodity,
            MALL_TYPE: this.maluerID
          }),{headers:{'token': this.customerID}})
          .then(res => {
            if(res.data.flag == '0'){
              this.Fidasul = '礼品兑换成功';
              this.Fisthint = 'block';
            }else{
              this.OrdeConnts = res.data.msg;
              this.OrdeAppden = 'block'
              let that = this
              setTimeout(function(){
                that.OrdeAppden = 'none';
              },1400)
            }
          })
          .catch(() => {
            console.log('获取数据失败');
          });
        }
      }
    },
    // 点击完成触发
    frclse(){
      this.Fisthint = 'none';
      this.$router.push({name: 'PaymentSuccessful',query:{totherewas: this.orcodity}});
    },
    // 点击返回上一层
    appHelmetreturn(){
      this.ordeCasier = 'block';
    }
  }
}
</script>
<style scoped>
  @import "obraocs/Ordesion.css";
</style>